import React from 'react'
import { BreckpointSpecificTitle } from '../../../../../Utils/Constants'
import { breckPointSpecificSubTitle, breckpointSpecificHead } from '../../../../../Data/Tables/ReactstrapTablesData/BasicTablesData'
import { Card, Col, Row } from 'reactstrap'
import CardHeaderSpan from '../../../../../Utils/CommonComponents/CardHeaderSpan'
import CommonTable from '../Common/CommonTable'
import { useLiveQuery } from 'dexie-react-hooks'
import { db } from '../../../../../db/userDB'

export default function BreckpointSpecific() {
    const employeeData = useLiveQuery(() => db.employee.toArray());
    const employeeRaw = employeeData?.[0]?.employeeList ?? [];
 const breckpointSpecificHead = [
    { id: 1, head: "Gradeid" },
    { id: 2, head: "CompanyId" },
    { id: 3, head: "GradeName Id" },

];
    const Employee = [
        Object.fromEntries(
            Object.entries(employeeRaw).filter(
                ([key, value]) =>
                    typeof value !== "object" || value === null // keep primitives only
            )
        ),
    ];

    const GradeMaster = [employeeRaw?.[0]?.GradeMaster];
    const Designations = [employeeRaw?.[0]?.Designations];
    const OrgUnit = [employeeRaw?.[0]?.OrgUnit];
    const Branch = [employeeRaw?.[0]?.Branch];

    const breckpointSpecificBody = [
        GradeMaster,

    ];
    return (
        <Col sm={3}>
            <Card>
                <CardHeaderSpan heading={'GradeMaster'} />
                <Row className="card-block">
                    <Col sm={12} lg={12} xl={12}>
                        <div className="table-responsive custom-scrollbar">
                            <CommonTable tableClass='light-card' headData={breckpointSpecificHead}>
                                {/* {breckpointSpecificBody.map((data) => ( */}
                                <tr>
                                    <th scope="row">{GradeMaster?.[0]?.Gradeid}</th>
                                    <td>{GradeMaster?.[0]?.CompanyId}</td>
                                    <td>{GradeMaster?.[0]?.GradeName}</td>

                                </tr>
                                {/* ))} */}
                            </CommonTable>
                        </div>
                    </Col>
                </Row>
            </Card>
        </Col>
    )
}
